import React, { useMemo, useState } from 'react';
import { Segment, Bubble, Col, Select, Card, Row, Button, Justify, Table, Icon } from 'tea-component';
import './index.scss';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import SelectChange from '@/pages/dashboard/pages/components/SelectCompoents/SelectChange';
import StrengthsTabCard from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Opinions/components/StrengthsTabCard';
import useOpinion from './_hooks';
import RadarChart from './component/TopicRadarChart';
import { useIntl, getLocale } from 'umi';

export default function StrengthsCard(props: any) {
  const {
    loadingNew,
    radarItemArr,
    radarLabelArr,
    topictabList,
    filterAll,
    language,
    setLanguage,
    selectedTopic,
    getSelectedTopic,
    RegionlList
  } = useOpinion(props)

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const languageList = useMemo(()=> {
     return RegionlList?.map(item=> ({...item, text: locale === 'zh-CN'? item?.text_zh: item?.text }))
  }, [locale, RegionlList])
  
  const languageName = useMemo(()=>{
    const targetLangues =  RegionlList?.find(item=> item?.value === language);
    if(targetLangues){
      return locale === 'zh-CN' ? targetLangues?.text_zh : targetLangues?.text;
    }
    return language;
  }, [locale, language])

  return (
    <div className='dbi-strength-card'>
      <CardSlot className='dbi-mobileGames-card-context'>
        <Justify
          className='strength-card-head'
          left={
            <div className='strength-card-title'>{formatMessage({id: 'dbi_detail_strengths_weakness'})}</div>
          }
          right={
            <div className='strength-card-select'>
              <Select
                className="select-item"
                appearance="button"
                options={languageList}
                value={language}
                matchButtonWidth
                onChange={(value: any) => {
                  setLanguage(value);
                }}
                button={(option) => (
                  <div className="dbi-select-button ">
                    <div className="select-button-text">{formatMessage({id: 'dbi_detail_translate'})}</div>
                    <span className='select-button-desc'>
                      {languageName}
                    </span>
                  </div>
                )}
              />
            </div>
          } 
        />

        <Row>
          <div
            className = 
            {
              (loadingNew)
                ? 'dbi-strength-card-loading'
                : 'dbi-strength-card-none'
            }
          >
            <Icon size="l" type="loading" />
            &nbsp;&nbsp;&nbsp;Loading…
          </div>
          <Col span={12}>
            <div>
              {
                (radarItemArr.length > 0 && radarLabelArr.length > 0 && !loadingNew) ? (
                  <RadarChart
                    radarItemArr={radarItemArr}
                    radarLabelArr={radarLabelArr}
                    selectedTopic={selectedTopic}
                  />
                ) : (
                  <div className = "dbi-strength-card-loading">
                    &nbsp;&nbsp;&nbsp;{formatMessage({id: 'dbi_detail_no_data_under'})}
                  </div>
                )
              }
              
            </div>
          </Col>
          <Col span={12}>
            <div className='strength-card-table'>
              {
                (radarLabelArr.length > 0 && !loadingNew) ? (
                  <StrengthsTabCard 
                    radarLabelArr={radarLabelArr}
                    param={topictabList}
                    filterAll={filterAll}
                    language={language}
                    getSelectedTopic={getSelectedTopic}
                  />
                ) : (
                  <div className = "dbi-strength-card-loading">
                    &nbsp;&nbsp;&nbsp;{formatMessage({id: 'dbi_detail_no_data_under'})}
                  </div>
                )
              }
            </div>
          </Col>
        </Row>
      </CardSlot>
    </div>
  )
}

